function dd(...data) {
    if (typeof data === 'undefined') {
        console.dir(data);
    } else {
        data.forEach((value) => {
            try {
                value = JSON.parse(JSON.stringify(value, null, 2));
            } catch (e) {
            }

            console.dir(value);
        });
    }
}

function _l(string) {
    if (!string) {
        return '';
    }

    if (!window.Evat.translations) {
        return string;
    }

    let translated = window.Evat.translations[string];
    if (!translated) {
        translated = string;
    }

    return translated;
}

/**
 * Makes non reactive copy of var
 * @param someVar
 * @returns {*}
 */
function copy(someVar) {
    someVar = JSON.stringify(someVar);
    someVar = JSON.parse(someVar);

    return someVar;
}

function redirect(url) {
    if (url === null || typeof url === 'undefined') {
        url = '';
    }
    if (url.trim().length < 1) {
        return;
    }

    window.location.href = url;
}

export {dd, _l, copy, redirect};
